export default __webpack_public_path__ + "static/media/promo-code-gold.c2ca80ae.svg";